import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CheckSquareFilledSvg from "@ant-design/icons-svg/es/asn/CheckSquareFilled";
import AntdIcon from "../components/AntdIcon";
var CheckSquareFilled = function CheckSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CheckSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CheckSquareFilled.displayName = 'CheckSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(CheckSquareFilled);